<template>
  <div class="footer">
    <main class="footer-content">
      <section class="socials">
        <div class="logo-companyName">
          <img src="@/assets/logo.png" alt="logo" />
          <h3>caby</h3>
        </div>
        <p class="footer-text">
          Caby is an initiative created to
          solve the problems of uncomfortable 
          transportation and bring more comfortable 
          and pleasurable ways.
        </p>
     
      </section>
      <div class="wrapper">
        <section class="container" v-for="content in footerContent">
          <h3>{{ content.title }}</h3>
          <ul class="links">
            <li v-for="list in content.links">{{ list.name }}</li>
          </ul>
        </section>
      </div>
      <section class="about">
        <h3>Contact us</h3>
        <p>You can contact Us to send email to us</p>
        <form action=" https://getform.io/f/626e1ed4-fd0a-483e-a4a4-9b22dd191542" method="POST">
          <div class="send-mail">
            <input type="mail" name="email" placeholder="Your mail" id="mail" required />
            <button type="submit"></button>
          </div>
        </form>
      </section>
    </main>
    <div class="horizontal-line"></div>
    <div class="copyright">&copy; 2022 caby | Powered by caby ride</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      footerContent: [
        {
          title: "About",
          links: [
            { name: "How it works" },
            { name: "Pricing" },
            { name: "Blog" }
          ],
        },
         {
          title: "Useful Links",
          links: [
             { name: "Contact Support" },
             { name: "Become A Driver" }
           ],
         }
      ],
    };
  },
};
</script>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400&display=swap");
.footer {
  background-color: #011a51;
  color: #fff;
  width: 100%;
  min-height: 300px;
  font-family: "Roboto", sans-serif;
}
.footer-content {
  display: flex;
  justify-content: space-between;
  padding: 30px 0;
  width: 100%;
  /* border:1px solid red; */
}
.socials {
  padding-left: 4rem;
}
.socials h3 {
  margin: 0 20px;
}
.logo-companyName {
  display: flex;
  align-items: center;
}
.logo-companyName img {
  width: 35px;
  height: 40px;
}
.footer-text{
  width:300px;
  padding:15px 0;
  line-height: 2; 
  font-weight: 600;

}
.wrapper {
  display: flex;
  justify-content: space-evenly;
  margin: 10px;
  width: 50%;
  /* border:1px solid red;   */
}

.links {
  margin: 30px 0;
}
.links li {
  min-width: 100px;
  margin: 20px 0;
  font-size:14px;
  list-style: none;
  cursor:pointer;
}
.about {
  width: 400px;
  margin-right: 2%;
  margin-top: 10px;
  /* border: 1px solid red; */
}
.about p {
  margin: 30px 0 10px;
}
.send-mail {
  position: relative;
}
#mail {
  padding: 10px 10px;
  border: none;
  margin: 5px 0;
  border-radius: 15px;
  width: 90%;
}
button {
  position: absolute;
  top: 15%;
  right: 11%;
  width: 30px;
  height: 30px;
  border: none;
  background: url("@/assets/send.png") 30%;
  border-radius: 50%;
}
.horizontal-line {
  width: 93%;
  border: 1px solid #d9d9d9;
  margin: 10px auto;
}
.copyright {
  text-align: center;
  padding: 10px;
}
@media screen and (max-width: 1024px) {
  .socials {
    padding-left: 2rem;
  }
  .container {
    margin-left: 1%;
  }
  .links li{
    font-size:12px;
  }
  .footer-text{
    font-size: 12px;
    font-weight: 400;
  }
}
@media screen and (max-width: 767px) {
  .footer-content {
    flex-direction: column;
    align-items: flex-start;
  }
  .socials {
    padding-left: 3rem;
  }
  .footer-text{
    font-size: 14px;
    font-weight: 400;
  }
  .wrapper {
    display: grid;
    grid-template-columns: 1fr;

  }
  .container{
    padding-left:2rem;
    }
}
.about {
  max-width: 90%; 
 padding:0px 3rem; 
}
@media screen and (max-width:368px) {
  .socials{
    padding-left:8%;
  }
  .footer-text{
    width:230px;
  }
  .container{
    padding-left:10%;
  }
  .about{
    max-width: 94%; 
    padding:0 9%;
  }
}
</style>
